
import {useEffect} from "react";

import cn from 'clsx'
import {useDispatch} from "react-redux";

import {useAppDispatch, useAppSelector} from "@App/hooks"
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'
import { ToolTip } from '@App/ui/crypto_exchange/desktop/components/controls/ToolTip'


import {
  asyncGetOrderTransactions,
  asyncGetTradeTransactions,
  MiniOrder,
  OrderTransaction, Transaction
} from "@Redux/slices/reports/ReportsSlice";
import {allOrderTransactions} from "@Redux/slices/reports/selectors";
import {currentWallet} from "@Redux/slices/user/selectors";


import {
  getTransactionTitle
} from "@UI/crypto_exchange/desktop/pages/spot/components/Reports/components/TransactionsTable";

import {
  formatDateFromApi,
  formatTimeFromApi,
  getTimestampFromPeriod,
  ReportsFilter,
  useCopyText
} from '../../model'

import s from './styles.module.scss'

const calculateNegative = (transaction: OrderTransaction) => {
  return transaction.trade.action_type === "sell";
}

export const OrdersTable = ({ onRowClick, filters }: { onRowClick?: (val: Transaction, title: string) => void, filters: ReportsFilter }) => {
  const transactions = useAppSelector(allOrderTransactions)
  const wallet = useAppSelector(currentWallet)
  const dispatch = useAppDispatch()

  const timestampFrom = getTimestampFromPeriod(filters.period)
  const args = {
    timestampInterval: {
      timestampFrom: timestampFrom,
      timestampTo:   null
    }
  }

  useEffect(() => {
    if (!wallet?.id) return
    dispatch(asyncGetOrderTransactions(args))
  }, [wallet?.id, filters])

  const columns: { title: string; width: string }[] = [
    { title: 'Date', width: '2%' },
    { title: 'Time', width: '2%' },
    { title: 'Market/ Size', width: '10%' },
    { title: 'Status', width: '9%' },
    { title: 'Type', width: '15%' },
    { title: 'Target price', width: '8%' },

    { title: 'ID', width: '1%' },
  ]

  const { copyText } = useCopyText()

  return (
    <div className={s.tableContainer}>
      <table className={s.table}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th style={{ width: col.width }} key={col.title} className={s[col.title.toLocaleLowerCase()]}>
                {col.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {transactions.map((transaction, index) => (
            <tr
              className={cn(s.row, s.fadeInRow)}
              key={transaction.trade.id}
              style={{ animationDelay: `${index * 40}ms` }}
              onClick={() => onRowClick?.(transaction, transaction.trade.action_type)}>
              <td className={s.col}>{formatDateFromApi(transaction.transaction_time)}</td>
              <td className={s.col}>{formatTimeFromApi(transaction.transaction_time)}</td>
              <td className={cn(s.col, s.info)}>
                <MarketIcon
                  symbol={transaction.market.symbol}
                />{' '}
                {transaction.market.title}
                <span className={cn(s.quantity, !calculateNegative(transaction) && s.buy)}>
                  {(calculateNegative(transaction) ? "-" : "+")  + transaction.trade.quantity}
                </span>
              </td>
              <td className={s.col}>{getTransactionTitle(transaction)}</td>
              <td className={s.col}>{transaction.trade.action_type}</td>
              <td className={s.col}>{transaction.trade.open_rate}</td>

              <td className={s.col}>
                <ToolTip content={<span className={s.toolTip}>{transaction.trade.front_id}</span>}>
                  <span className={s.idBadge} onClick={() => copyText(transaction.trade.front_id)}>
                    ID
                  </span>
                </ToolTip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
